// Shared class strings for the Sunset Console components

// Join class names, skipping empty ones
export const cx = (...classes) => classes.filter(Boolean).join(' ');

// 2px amber ring with a 2px offset, on every interactive element
export const focusRing =
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus';

// Short motion that only confirms an action, and none for people who ask for less
export const motion = 'duration-motion motion-reduce:transition-none';

// Closed panels take the hidden attribute and no display class: a display utility such as flex
// would override [hidden] { display: none }, since both have the same specificity.

// A 32px round icon disc (change rows, Nothing urgent, the first-version note)
export const disc = 'w-8 h-8 flex-none rounded-full inline-flex items-center justify-center';
